import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Socket } from 'ngx-socket-io';
import * as _ from 'lodash';
import { MessagesService } from 'services/messages/messages.service';
import { CryptService } from 'services/crypt/crypt.service';


const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
    //Variables de Interfaz
    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private _router: Subscription;
    public loader: boolean = false;

    modal1 = document.getElementById("modal1")
    modalFade = document.getElementById("modal1-fade")
    hideselect: boolean = true;
    hideuser: boolean = false;




    @ViewChild('app-navbar-cmp') button: any;

    constructor(
        location: Location,
        private renderer: Renderer,
        private element: ElementRef,
        private router: Router,
        public crypt: CryptService,) {

        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;

    }



    minimizeSidebar() {
        setTimeout(function () {
            //    body.classList.add('sidebar-mini');

            misc.sidebar_mini_active = true;

        }, 300);

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    hideSidebar() {
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];

        if (misc.hide_sidebar_active === true) {
            setTimeout(function () {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');

        } else {
            setTimeout(function () {
                body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    ngOnInit() {
        $(document).ready(() => {
            $('.visible').click(() => {
                console.log("entra")
                $(".main-content").removeClass(".contentb")
            });
            $("#mod1").click(() => {
                this.hideselect = false
                this.hideuser = true
            })
            $("#mod2").click(() => {
                this.hideselect = true
                this.hideuser = false
            })
        });

        $(".toggle").click(function () {
            $(".notifySidebar").toggleClass('active');
            $(".close-layer-ntf").toggleClass('none');
            setTimeout(() => {
                $(".close-layer-ntf").toggleClass('hide');
            }, 300);
        });

        $(".close-layer-ntf").click(function () {
            $(".notifySidebar").toggleClass('active');
            $(".close-layer-ntf").toggleClass('hide');
            setTimeout(() => {
                $(".close-layer-ntf").toggleClass('none');
            }, 300);
        });

        misc.sidebar_mini_active = false;
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('sidebar-mini');
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });
    }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }
    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        this.sidebarVisible = true;
    };

    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        $(".main-content").removeClass("contentb")
    };

    sidebarToggle() {
        setTimeout(() => {
            this.sidebarOpen();
        }, 500);
        const body = document.getElementsByTagName('body')[0];
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        if (this.mobile_menu_visible == 1) {
            // $('html').removeClass('nav-open');
            body.classList.remove('nav-open');
            setTimeout(function () {
                $toggle.classList.remove('toggled');
            }, 400);
            this.mobile_menu_visible = 0;
        } else {
            $(".main-content").addClass("contentb")
            setTimeout(function () {
                $toggle.classList.add('toggled');
            }, 430);

            var $layer = document.createElement('div');
            $layer.setAttribute('class', 'close-layer');


            if (body.querySelectorAll('.main-panel')) {
                document.getElementsByClassName('main-panel')[0].appendChild($layer);
            } else if (body.classList.contains('off-canvas-sidebar')) {
                document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
            }

            setTimeout(function () {
                $layer.classList.add('visible');
            }, 100);

            $layer.onclick = () => { //asign a function
                body.classList.remove('nav-open');

                this.mobile_menu_visible = 0;
                $layer.classList.remove('visible');
                setTimeout(() => {
                    $(".main-content").removeClass("contentb")
                    $layer.remove();
                    $toggle.classList.remove('toggled')
                }, 400);
            }
            body.classList.add('nav-open');
            this.mobile_menu_visible = 0;

        }
    }

    getTitle() {

        let titlee: any = this.location.prepareExternalUrl(this.location.path());
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return 'Portal institucional Colegio León de Greiff';
    }
    getPath() {

        return this.location.prepareExternalUrl(this.location.path());


    }

    close() {
        this.router.navigate(['pages/login']);
        localStorage.setItem('session', '0');
        window.localStorage.clear();
    }




    modalTrigger() {

        //Codigo de Interfaz
        this.modal1 = document.getElementById("modal1")
        this.modalFade = document.getElementById("modal1-fade")
        if (!this.modal1.classList.contains("modal-in")) {
            this.modal1.classList.remove("modal-out")
            this.modal1.classList.add("modal-in")
            this.modalFade.classList.remove("modal-fade-out")
            this.modalFade.classList.add("modal-fade-in")
        } else if (!this.modal1.classList.contains("modal-out")) {
            this.modal1.classList.remove("modal-in")
            this.modal1.classList.add("modal-out")
            this.modalFade.classList.remove("modal-fade-in")
            this.modalFade.classList.add("modal-fade-out")
        }


    }

    fadeTrigger() {
        this.modal1 = document.getElementById("modal1")
        this.modalFade = document.getElementById("modal1-fade")
        this.modal1.classList.remove("modal-in")
        this.modal1.classList.add("modal-out")
        this.modalFade.classList.remove("modal-fade-in")
        this.modalFade.classList.add("modal-fade-out")
        this.modal1.classList.remove("minimize-out")
        this.modal1.classList.remove("minimize-in")
    }


    openModule() {

        this.router.navigate(['users/sessions']);

    }

}

